const TodayDate = () => {
  const today = new Date();
  const formattedDate = today.toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="dark:text-white text-black text-sm font-semibold">
      Today : <span className="font-normal">{formattedDate}</span>
    </div>
  );
};

export default TodayDate;
